'use client'

import { useState, useEffect, useCallback } from 'react'
import ReactDOM from 'react-dom'
import cn from 'clsx'

import X from '../../images/x'

import s from './Modal.module.sass'

interface BackdropProps {
    children: React.ReactNode
    close: () => void
    noBackground?: boolean
    hideClose?: boolean
    triggerClose?: boolean
    centred?: boolean
}

const Modal = ({ children, close, noBackground, hideClose, triggerClose, centred }: BackdropProps) => {
    const [showModal, setShowModal] = useState(false)
    const [fadeOut, setFadeOut] = useState(false)

    function disableScrolling() {
        const x = window.scrollX
        const y = window.scrollY

        window.onscroll = function () {
            window.scrollTo(x, y)
        }
    }

    function enableScrolling() {
        window.onscroll = function () {}
    }

    useEffect(() => {
        if (children) {
            setShowModal(true)
            disableScrolling()
        } else {
            setShowModal(false)
        }
    }, [children])

    const closeModal = useCallback(() => {
        setFadeOut(true)
        setTimeout(() => {
            close()
        }, 150)
        enableScrolling()

        const url = new URL(window.location.href)
        url.searchParams.delete('m')
        window.history.pushState({}, '', url)
    }, [close])

    useEffect(() => {
        const closeOnEscapeKey = (e: any) => (e.key === 'Escape' ? closeModal() : null)
        document.body.addEventListener('keydown', closeOnEscapeKey)

        return () => {
            document.body.removeEventListener('keydown', closeOnEscapeKey)
        }
    }, [closeModal])

    useEffect(() => {
        if (triggerClose) {
            closeModal()
        }
    }, [triggerClose, closeModal])

    return ReactDOM.createPortal(
        <div
            className={cn(
                s.Modal,
                showModal && s.Show,
                fadeOut && s.FadeOut,
                noBackground && s.NoBackground,
                centred && s.Centred,
            )}
        >
            <div className={s.Backdrop} onClick={closeModal} />
            <div className={s.ModalContainer}>
                <div className={s.ModalMain}>
                    <div>{children}</div>
                </div>
                {hideClose ? null : (
                    <div className={s.Close} onClick={closeModal}>
                        {X}
                    </div>
                )}
            </div>
        </div>,
        document.getElementById('modal') as HTMLElement,
    )
}

export default Modal
